import EventBus from "./event-bus";
import { EVENTS, PRODUCT_TYPES } from './constants';
import UrlService from './url-service';
import UiServiceDelegate from '../services/ui-service-delegate';
import ShopService from '../services/shop-service';
import CartService from '../services/cart-service';
import $ from 'jquery';
import { Deferred } from "../../types";
import ImageCropper from '../admin-components/ImageCropper.vue';
import ModalService from '../services/modal-service';
import DataStore from '../services/data-store';
import UiModalService from './UiModalService';

require('javascript-detect-element-resize')

	let factory = {
		adminNavbarScroll: 0,
		simplebarScrollIntoView,
		showSisterShopsModal,
		showClientLoginModal,
		showClientSignupModal,
		showClientForgotPassModal,
		showReservationModal,
		showAdminReservationModal,
		toggleCart(state) {
			UiServiceDelegate.toggleCart(state);
		},
		toggleSidebar(state) {
			UiServiceDelegate.toggleSidebar(state);
		},
		openTicketModal,
		openCheckoutModal,
		get isMobileView() {
			return $(document).width() < 768;
		},
		shouldShowNavbar,
		displayImageCropperModal,
		scrollModalToTop,
		get isCartOpen() {
			return UiServiceDelegate.isCartOpen;
		},
		get isSidebarOpen() {
			return UiServiceDelegate.isSidebarOpen;
		},
		get activeItem() {
			return UiServiceDelegate.getActiveItem();
		},
		get openSideMenu() {
			return UiServiceDelegate.openSideMenu;
		},
		hasActiveChild,
		editOptionGroups,
		go,
		showDetails,
		showVitrine,
		showOptions,
		selectItem,
		openLandingModal,
		currentPromoCode: null,
		scrollToVisible,
		getTopOfView,
		editAddress,
	};

	export default factory;

	init();

	function init() {
		EventBus.$on(EVENTS.shopChanged,() => setTimeout(updateTopOfView));
		listenToKeyboardOpen();

		// init the function to calculate height of viewport and add css custom property --vh
		setDocHeight();
		window.addEventListener('resize', function () {
			setDocHeight();
			updateTopOfView();
		});
		window.addEventListener('orientationchange', function () {
			setDocHeight();
			updateTopOfView();
		});
	}

	function editAddress(address,client) {
		UiModalService.editAddress(address, client);
	}
	function showReservationModal() {
		UiModalService.showReservationModal();
	}
	function showAdminReservationModal() {
		UiModalService.showAdminReservationModal();
	}

	function updateTopOfView() {
		document.documentElement.style.setProperty('--topOfView', Math.round(getTopOfView()) + 'px')
	}

	function getTopOfView() {
		return UiServiceDelegate.getTopOfView();
	}

	function simplebarScrollIntoView($el, currentLi) {
		let scrollElement = $($el).find('.simplebar-content-wrapper')[0];
		if (!scrollElement) return;
		let liRect = currentLi.getBoundingClientRect();
		let scrollRect = scrollElement.getBoundingClientRect();
		if (liRect.right > scrollRect.right) {
			scrollElement.scrollLeft += liRect.right - scrollRect.right;
		}
		if (liRect.left < scrollRect.left) {
			scrollElement.scrollLeft += liRect.left - scrollRect.left;
		}
	}

	function scrollToVisible(list = null, item?, topOffset?: number, bottomOffset?: number) {
		if (!item) {
			list.animate({scrollTop: 0 });
			return;
		}
		let itemRect = item[0].getBoundingClientRect();
		let listRect, scrollTop
		if (list) {
			listRect = list[0].getBoundingClientRect();
			scrollTop = list.scrollTop()
		} else {
			listRect = {
				top: 0,
				bottom: window.innerHeight,
			}
			scrollTop = window.scrollY
		}
		let minValue = listRect.top + topOffset;
		let maxValue = listRect.bottom - bottomOffset;
		if (itemRect.top < minValue) {
			let s2 = itemRect.top - minValue + scrollTop;
			if (list) {
				list.animate({scrollTop: s2 });
			} else {
				window.scrollTo({ top: s2, behavior: 'smooth'})
			}
		} else if (itemRect.bottom > maxValue) {
			let s = itemRect.bottom - maxValue + scrollTop;
			if (list) {
				list.animate({scrollTop: s });
			} else {
				window.scrollTo({ top: s, behavior: 'smooth'})
			}
		}
	}

	function listenToKeyboardOpen() {
		$(document).on('focus blur', 'select, textarea, input[type=text], input[type=tel], input[type=date], input[type=password], input[type=email], input[type=number]', function (e) {
			var nowWithKeyboard = (e.type == 'focusin');
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				$('body').toggleClass('view-withKeyboard', nowWithKeyboard);
			}
		});
	}

	function setDocHeight(){
		// grab the height of the viewport and add property css to root html style property
		document.documentElement.style.setProperty('--vh', `${(window.innerHeight - 0.5) / 100}px`);
	}

	function defer(): Deferred {
		let deferred: Deferred = {
			promise: null,
			resolve: null,
			reject: null,
		}
		let p = new Promise((resolve, reject) => {
			deferred.resolve = resolve;
			deferred.reject = reject;
		})
		deferred.promise = p;
		return deferred;
	}

	function editOptionGroups(optionGroup) {
		EventBus.$emit(EVENTS.modal.editOptionGroups,optionGroup);
	}

	function hasActiveChild(item) {
		for(let i in item.childs) {
			if (factory.activeItem === item.childs[i]) {
				return true;
			}
			if (this.hasActiveChild(item.childs[i])) {
				return true;
			}
		}
		return false;
	}

	function scrollModalToTop() {
		$('.modal').scrollTop(0);
	}

	function displayImageCropperModal(image, aspectRatio, originalFilename) {
		let modal = ModalService.open(ImageCropper, { image, imageName: originalFilename, aspectRatio });
		modal.result.finally(() => DataStore.notifyAngularJs());
		return modal;
	}

	function shouldShowNavbar() {
		return !UrlService.includes('admin-signup') && !UrlService.includes('admin-login') && !UrlService.includes('map-restos') ;
	}

	function openLandingModal() {
		UiModalService.openLandingModal();
	}

	function openCheckoutModal() {
		UiModalService.openCheckoutModal();
	}

	function openTicketModal(ticket) {
		UiModalService.openTicketModal(ticket);
	}

	function showSisterShopsModal(shop) {
		UiModalService.showSisterShopsModal(shop);
	}

	function showClientForgotPassModal(email) {
		UiModalService.showClientForgotPassModal(email);
	}

	function showClientSignupModal(showCheckout = false) {
		return UiModalService.showClientSignupModal(showCheckout);
	}

	function showClientLoginModal(showCheckout = false) {
		return UiModalService.showClientLoginModal(showCheckout);
	}

	function go(cart, item) {
		if (item.product.ty == PRODUCT_TYPES.Category) {
			if (!UiServiceDelegate.scrollIntoView(item,true)) {
				UrlService.go({name:'carte',params:{tid: item.tid}});
			}
		} else if (item.product.ty == PRODUCT_TYPES.Menu) {
			if (ShopService.shop.canOrder) {
				if (!UiServiceDelegate.scrollIntoView(item,true)) {
					UrlService.go({name:'carte',params:{tid: item.tid}});
				}
			} else {
				showVitrine(cart, item);
			}
		} else {
			if (!ShopService.shop.canOrder || item.product.upsell_to) {
				showVitrine(cart, item);
			} else {
				selectItem(cart, item);
			}
		}
	}

	function showDetails(cart, item) {
		if (item.product.ty == PRODUCT_TYPES.Category) {
			go(cart, item);
		} else {
			if (isProductWithOptions(item) && ShopService.shop.canOrder) {
				showOptions(cart, item);
			} else {
				showVitrine(cart, item);
			}
		}
	}

	function isProductWithOptions(item) {
		return item.product.ty == PRODUCT_TYPES.Product && item.product.options.length;
	}

	function showVitrine(cart, item) {
		return showItemModal(cart, item, true);
	}

	function showOptions(cart, item, inMenu = false) {
		return showItemModal(cart, item, false, inMenu);
	}

	function selectItem(cart, item, inMenu = false) {
		if (item.product.options.length) {
			showItemModal(cart, item, false, inMenu)
		} else {
			CartService.addToCart(cart, item);
		}
	}

	function showItemModal(cart, item, vitrine, inMenu = false) {
		UiModalService.showItemModal(cart, item, vitrine, inMenu);
	}

